// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BillStatusAndTypeFragmentDoc, ApprovalStatusFragmentDoc, DocumentEditorDetailFragmentDoc, ApproverUserDetailFragmentDoc } from '../../../fragments/circularFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SubmitApprovalMutationVariables = Types.Exact<{
  input: Types.SaveApprovalInput;
}>;


export type SubmitApprovalMutation = { __typename?: 'Mutation', saveApproval: { __typename?: 'SaveApprovalResult', approval: { __typename?: 'Approval', id: string, subject: { __typename?: 'Bill', id: string, approval?: { __typename?: 'Approval', id: string, name: string, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string } } | null | undefined } | { __typename?: 'ChangeEvent' } | { __typename?: 'ChangeRequest' } | { __typename?: 'Invoice', id: string, approval?: { __typename?: 'Approval', id: string, name: string, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string } } | null | undefined } } } };

export type SubmitApproval_BillFragment = { __typename?: 'Bill', id: string, approval?: { __typename?: 'Approval', id: string, name: string, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string } } | null | undefined };

export type SubmitApproval_InvoiceFragment = { __typename?: 'Invoice', id: string, approval?: { __typename?: 'Approval', id: string, name: string, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string } } | null | undefined };

export const SubmitApproval_BillFragmentDoc = gql`
    fragment SubmitApproval_Bill on Bill {
  id
  approval {
    ...ApprovalStatus
  }
}
    ${ApprovalStatusFragmentDoc}`;
export const SubmitApproval_InvoiceFragmentDoc = gql`
    fragment SubmitApproval_Invoice on Invoice {
  id
  approval {
    ...ApprovalStatus
  }
}
    ${ApprovalStatusFragmentDoc}`;
export const SubmitApprovalDocument = gql`
    mutation SubmitApproval($input: SaveApprovalInput!) {
  saveApproval(input: $input) {
    approval {
      id
      subject {
        ...SubmitApproval_Bill
        ...SubmitApproval_Invoice
      }
    }
  }
}
    ${SubmitApproval_BillFragmentDoc}
${SubmitApproval_InvoiceFragmentDoc}`;
export type SubmitApprovalMutationFn = Apollo.MutationFunction<SubmitApprovalMutation, SubmitApprovalMutationVariables>;

/**
 * __useSubmitApprovalMutation__
 *
 * To run a mutation, you first call `useSubmitApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitApprovalMutation, { data, loading, error }] = useSubmitApprovalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitApprovalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitApprovalMutation, SubmitApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitApprovalMutation, SubmitApprovalMutationVariables>(SubmitApprovalDocument, options);
      }
export type SubmitApprovalMutationHookResult = ReturnType<typeof useSubmitApprovalMutation>;
export type SubmitApprovalMutationResult = Apollo.MutationResult<SubmitApprovalMutation>;
export type SubmitApprovalMutationOptions = Apollo.BaseMutationOptions<SubmitApprovalMutation, SubmitApprovalMutationVariables>;